import React, { memo } from 'react';
import { AppNode } from '@/types';
import { AlertCircle, Mic2, Play } from 'lucide-react';
import { GridOverlay, AudioVisualizer } from '../GridOverlay';
import { NODE_TYPE_ICON_URLS } from '../NodeTitle';

export const AudioContent: React.FC<{
  data: AppNode;
  isWorking: boolean;
  hasError: boolean;
  mediaRef: React.RefObject<HTMLImageElement | HTMLVideoElement | HTMLAudioElement | null>;
  isPlayingAudio: boolean;
  setIsPlayingAudio: (v: boolean) => void;
}> = memo(({ data, isWorking, hasError, mediaRef, isPlayingAudio, setIsPlayingAudio }) => (
  <div className="w-full h-full flex flex-col justify-center items-center relative overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-pink-500/10 to-purple-900/10 z-0" />
    {data.data.audioUri ? (
      <div className="flex flex-col items-center gap-4 w-full z-10">
        <audio
          ref={mediaRef as any}
          src={data.data.audioUri}
          onEnded={() => setIsPlayingAudio(false)}
          onPlay={() => setIsPlayingAudio(true)}
          onPause={() => setIsPlayingAudio(false)}
          className="hidden"
        />
        <div className="w-full px-4"><AudioVisualizer isPlaying={isPlayingAudio} /></div>
        <div className="flex items-center gap-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              const audio = mediaRef.current as HTMLAudioElement;
              if (audio?.paused) { audio.play(); setIsPlayingAudio(true); }
              else { audio?.pause(); setIsPlayingAudio(false); }
            }}
            className="w-12 h-12 rounded-full bg-cyan-500/20 hover:bg-cyan-500/40 border border-cyan-500/50 flex items-center justify-center transition-all hover:scale-105"
          >
            {isPlayingAudio ? <span className="text-[10px]">⏸</span> : <span className="text-[10px]">▶</span>}
          </button>
        </div>
      </div>
    ) : (
      <div className="flex flex-col items-center justify-center z-10 select-none">
        {NODE_TYPE_ICON_URLS[data.type] ? (
          <img src={NODE_TYPE_ICON_URLS[data.type]} alt="" className={`transition-opacity duration-300 ${isWorking ? 'opacity-90' : 'opacity-90'}`} style={{ width: 48, height: 48 }} draggable={false} />
        ) : (
          <Mic2 size={48} className={`transition-opacity duration-300 ${isWorking ? 'text-pink-400/90' : 'text-white/90'}`} />
        )}
      </div>
    )}
    {hasError && (
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md flex flex-col items-center justify-center p-6 text-center z-20">
        <AlertCircle className="text-red-500 mb-2" size={20} />
        <span className="text-xs text-red-200">{data.data.error}</span>
      </div>
    )}
  </div>
));
